<template>
  <div class="iv-system iv-p-t-24">
    <div class="iv-main-width">
      <Tab :navList="navList" @on-click="tabClick"></Tab>
      <List v-if="list.length > 0" type="system" :showPage="true" class="iv-m-t-24"></List>
      <NoData v-if="list.length <= 0"></NoData>
    </div>
  </div>
</template>

<script>
import Tab from '@/components/tab'
import NoData from '@/components/no-data'
import List from '@/components/declare-list'

export default {
  data () {
    return {
      list: []
    }
  },
  created () {
    this.initTabs()
  },
  methods: {
    tabClick (name) {
    },
    initTabs () {
      this.navList = [{
        label: '全部'
      }, {
        label: 'xxxx标签'
      }, {
        label: 'xxxx标签'
      }]
    }
  },
  components: {
    Tab,
    List,
    NoData
  }
}
</script>

<style lang="scss" scoped>
.iv-system {
  height: 100%;;
  background-color: #fff;
}
</style>
